import { cn } from "../../lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-md bg-muted shadow-inset before:absolute before:inset-0 before:animate-sx-shimmer before:bg-[linear-gradient(100deg,transparent_20%,hsl(var(--foreground)/0.06)_50%,transparent_80%)] before:bg-[length:200%_100%] motion-reduce:before:animate-none",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
